import { User, UserManager, WebStorageStateStore } from 'oidc-client-ts';

let manager: UserManager | undefined;

function clearLegacyPersistentOidcSession() {
  // Earlier builds used localStorage for oidc-client-ts. Remove only that
  // library's persisted user entries; other application preferences remain.
  for (let index = localStorage.length - 1; index >= 0; index -= 1) {
    const key = localStorage.key(index);
    if (key?.startsWith('oidc.user:')) localStorage.removeItem(key);
  }
}

export function getOidcManager(): UserManager {
  clearLegacyPersistentOidcSession();
  manager ??= new UserManager({
    authority: process.env.REACT_APP_OIDC_AUTHORITY!,
    client_id: process.env.REACT_APP_OIDC_CLIENT_ID || 'seeward-web',
    redirect_uri: `${window.location.origin}/auth/callback`,
    silent_redirect_uri: `${window.location.origin}/auth/silent-renew`,
    post_logout_redirect_uri: `${window.location.origin}/login`,
    response_type: 'code',
    scope: process.env.REACT_APP_OIDC_SCOPE || 'openid profile email',
    // Browser tokens must not survive closing the browser session. Keycloak's
    // own SSO session remains the source of truth and silently issues new ones.
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    automaticSilentRenew: false,
    monitorSession: true
  });
  return manager;
}

export function oidcUserToSession(user: User) {
  return {
    access_token: user.access_token,
    refresh_token: user.refresh_token,
    id_token: user.id_token,
    expires_at: user.expires_at,
    token_type: user.token_type,
    user: user.profile
  };
}

export async function refreshOidcSession() {
  const user = await getOidcManager().signinSilent();
  if (!user?.access_token) throw new Error('Keycloak did not return an access token');
  return user;
}
